<template>
    <div>
        <CHead :oHead="Head"></CHead>
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-12">
                <Clist :EmitSeccion="EmitSeccion" :regresar="regresar" :Nombre="NameList" @FiltrarC="Lista" :Filtro="Filtro" :isModal="EsModal" :pShowBtnAdd="btnadd" :ShowHead="false" :ShowFilas="false" :pConfigLoad="ConfigLoad">
					<template slot="Filtros">
						<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.Item" placeholder="Item..." @input="Filtrar">
						<button v-if="ShowBotons" :disabled="DisableBtnExport" type="button" @click="ExportarExcel" class="btn btn-01 mr-2"><i class="fa fa-file-excel"></i> Generar Excel</button>
						<input v-if="ShowBotons" style="display:none" id="ArchivoHoja" @change="SubirArchivo" type="file" ref="file">
						<label v-if="ShowBotons" for="ArchivoHoja" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
						<span v-if="ShowBotons">{{Archivo}}</span>
						<button v-if="ShowBotons" :disabled="DisableBtnImport" type="button" @click="ImportarExcel" class="btn btn-pink ml-auto"><i class="fa fa-file-upload"></i> Subir Archivo</button>
					</template>
                    <template slot="header">
                        <tr>
                            <th>SKU</th>
                            <th>Ítem</th>
							<th>Descripción</th>
							<th>Unidad</th>
							<th>Stock</th>
                            <th>Costo Unitario</th>
							<th>Fecha Cantidad</th>
							<th>Fecha Stock</th>
                            <th>Acciones</th>
                        </tr>
                    </template>
    
                    <template slot="body">
                        <tr v-for="(lista,index) in ListaEquipo" :key="index" >
                            <td v-b-tooltip.hover.top :title="lista.Codigo" class="text-nowrap" width="10%">{{$limitCharacters(lista.Codigo,20) }}</td>
                            <td v-b-tooltip.hover.top :title="lista.Item" class="text-nowrap" width="18%">{{$limitCharacters(lista.Item,30) }}</td>
							<td v-b-tooltip.hover.top :title="lista.Nombre" class="text-nowrap" width="5%">{{$limitCharacters(lista.Nombre,30) }}</td>
							<td class="text-nowrap" width="5%">{{lista.Unidad }}</td>
							<td class="text-nowrap" width="5%">{{lista.Stock }}</td>
                            <td class="text-nowrap" width="5%">$ {{Number(lista.Precio).toLocaleString('es-MX') }}</td>
							<td><i class="fa fa-calendar"></i> {{lista.FechaPrecio!=null ? $getCleanDate(lista.FechaPrecio,false) : 'S/F' }}</td>
							<td><i class="fa fa-calendar"></i> {{lista.FechaStock!=null ? $getCleanDate(lista.FechaStock,false) : 'S/F' }}</td>
                                <td>
                                    <Cbtnaccion :pEmitSeccion="EmitSeccion" :isModal="EsModal" :Id="lista.IdEquipoCot" :IrA="FormName" >
										<template slot="btnaccion">
											<span>
												<button v-if="!ShowBotons" type="button" @click="Add_Equipo(lista)" class="btn-icon mr-2" ><i class="fa fa-plus-circle"></i></button>
											</span>
										</template>
									</Cbtnaccion>
                                    <!-- <button v-else type="button" @click="Add_Equipo(lista)" class="btn btn-table" ><i class="fa fa-plus-circle"></i></button> -->
                                </td>
                        </tr>
                        <CSinRegistros :pContIF="ListaEquipo.length" :pColspan="9" ></CSinRegistros>
                    </template>
    
                </Clist>
    
                <Modal :pEmitSeccion="EmitSeccion" :NameModal="'Equipo'" v-if="btnadd" :size="size" :Nombre="NameForm" :poBtnSave="oBtnSave" >
                    <template slot="Form">
                    <Form :NameList="NameForm"  :poBtnSave="oBtnSave" ></Form>
                    </template>
                </Modal>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/catalogos/cotizacion/equipo/Form.vue';
import CHead from "@/components/CHead.vue";
import CSinRegistros from "../../../../components/CSinRegistros";

export default {
    name :'listCotizacionConfEquipo',
    props:["pTipo"],
    components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        CHead,
		CSinRegistros
    },
    data() {
        return {
			EmitSeccion:'Equipo',
            FormName:'Equipo',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-lg",
            NameList:"Equipos",
            NameForm:"Equipo",
            urlApi:"cotizacion_equipo/get",
            ListaEquipo:[],
            ListaHeader:[],

            Rutaicono:'',
            regresar:true,
            ShowBotons:true,
            btnadd:true,  ShowAcciones:true,
              Filtro:{
                Nombre:'',
                Placeholder:'SKU..',
                 TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:''
            },  oBtnSave:{//valores  isModal(true),nombreModal('ModalForm'),tipoModal=1,regresarA(''),disableBtn(false),txtSave('Guardar'),txtCancel('Cerrar');
                	isModal:true,
                	disableBtn:false,
                	toast:0,
					EmitSeccion:'Equipo',
					nombreModal:'Equipo'
            },
            Head: {
				ShowHead: true,
				Title: "Equipos",
				BtnNewShow: true,
				BtnNewName: "Nuevo",
				isreturn: true,
				isModal: true,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false,
				EmitSeccion:'Equipo'
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			DisableBtnExport:false,
			DisableBtnImport:false,
			EquiposTodos:[],
			Archivo:null,
			TimeOut:''
        }
    },
    methods: {
        async Lista() {
		    this.ConfigLoad.ShowLoader = true;
		    await this.$http.get(
		    	this.urlApi,
		    	{
		    		params:{Nombre:this.Filtro.Nombre,Entrada:this.Filtro.Entrada,pag:this.Filtro.Pagina,Item:this.Filtro.Item, RegEstatus:'A'}
		    	}
		    ).then( (res) => {
		    	this.ListaEquipo =res.data.data.row;
		    	this.Filtro.Entrada=res.data.data.pagination.PageSize;
		    	this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				this.EquiposTodos=res.data.data.todos;
		    }).finally(()=>{
		    	this.ConfigLoad.ShowLoader = false;
		    });
	    },
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},
        Eliminar(Id){

            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {

                    this.$toast.success('Información eliminada');

                     this.$http.delete(
                            'cotizacion_material/' + Id
                        ).then( (res) => {
                                this.Lista();
                        });

                    }
                });
        },
        Change(titulo)
        {
            this.NameForm=titulo;
            var bdn=true;
            if(titulo=='Iconos'){
                bdn=false;
            }
            this.bus.$emit('cambiar_CloseModal',bdn);
        },Limpiar(){
            this.bus.$emit('cambiar_CloseModal',true);
        },Add_Equipo(obj){

            this.bus.$emit('Add_Equipos',obj);
            $('#ModalForm2').modal('hide');
        },
		ExportarExcel(){
			let formData=new FormData();
			formData.set('Equipos',JSON.stringify(this.EquiposTodos));
			this.DisableBtnExport=true;
			this.$http.post('cotizacion_equipo/excel',formData,{
                responseType: 'blob',
            }).then((res)=>{
				let ExcelContent = res.data;
				let file = new Blob([ExcelContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let fileUrl = URL.createObjectURL(file);
				var a = document.createElement('a');
  				a.href = fileUrl;
  				a.download = 'equipos';
  				document.body.append(a);
  				a.click();
  				a.remove();
  				URL.revokeObjectURL(fileUrl);
			}).finally(()=>{
				this.DisableBtnExport=false;
			});
		},
		ImportarExcel(){
			// console.log(this.$refs.file.files[0]);
			this.DisableBtnImport=true;
			let formData=new FormData();
			formData.append('Archivo',this.$refs.file.files[0]);
			this.$http.post('cotizacion_equipo/excelimport',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.$toast.success('Los Equipos se Han Registrado Correctamente');
				this.$refs.file.files[0]=null;
				this.DisableBtnImport=false;
			}).finally(()=>{
				// this.Archivo='';
				this.Lista();
			}).catch((err)=>{
				this.DisableBtnImport=false;
			})
		},
		SubirArchivo(){
			const image = this.$refs.file.files[0];
			var FileSize = image.size / 1024 / 1024; // in MB
			if (FileSize > 1) {
				this.$toast.info('Solo se puede subir archivos menores a 1 MB');
				const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
			}
			var allowedExtensions = /(\.xlsx|\.XLSX)$/i;
			if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .xlsx');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='';
                return false;
            }
			this.Archivo=image.name;
		}
    },
    created()
    {

        this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List_'+this.EmitSeccion);
        this.bus.$off('Limpiar');
         this.bus.$off('Regresar');
        // this.Lista();

        if(this.pTipo!==undefined){
           if(this.pTipo===2){
                this.regresar=false;
                this.ShowBotons=false;
                // this.btnadd=false;
				// this.Head.ShowHead = false;
                this.bus.$emit('Cambiar_Footer',false);
           }
        }else {
			this.pTipo = 1;
		}

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);

        });
         this.bus.$on('List_'+this.EmitSeccion,()=>
        {
            this.Lista();
        });

        this.bus.$on('Limpiar',()=>
        {
            this.Limpiar();
        });
         this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'submenucotizacion'});
        });
    },
    mounted() {
        this.Lista();
    },
}
</script>

<style>

</style>
